import {Component, Input, OnInit} from '@angular/core';
import {OrderFieldFunction, OrderFieldModel, SelectUtils, UiConstants} from '../../../../util/core-utils';
import {OrderField} from '../../../../lib/query/orderfields';
import {OrderType, QueryResult} from '../../../../lib/util/services';
import {FilterField} from '../../../../lib/query/filterfields';
import {CriteriaBuilder} from '../../../../util/model-utils';
import {RightModel} from '../../../../app.rights';
import {ConfigurationService} from '../../../../lib/configuration/configuration.service';
import {TaskRecordOutgoingSmsSearch} from "../../../../lib/sms/outgoing/task-record-outgoing-sms-search.service";
import {OutgoingSms, TaskRecordOutgoingSmsService} from "../../../../lib/sms/outgoing/task-record-outgoing-sms.service";
import {MatDialog} from "@angular/material/dialog";
import {
  TaskRecordOutgoingSmsSendDialogComponent
} from "../dialogs/task-record-outgoing-sms-send-dialog/task-record-outgoing-sms-send-dialog.component";
import {SmsTemplate} from "../../../../lib/sms/sms-template/sms-template.service";

@Component({
  selector: 'app-task-record-outgoing-sms-list',
  templateUrl: './task-record-outgoing-sms-list.component.html',
  styleUrls: ['./task-record-outgoing-sms-list.component.scss']
})
export class TaskRecordOutgoingSmsListComponent implements OnInit {

  @Input()
  taskRecordId: number;

  @Input()
  taskId: number;

  @Input()
  rightModel: RightModel = RightModel.empty();

  UiConstants = UiConstants;
  SelectUtils = SelectUtils;
  TaskRecordOutgoingSmsSearch = TaskRecordOutgoingSmsSearch;

  queryModel: OrderFieldModel<OrderField.OutgoingSms>
    = new OrderFieldModel(TaskRecordOutgoingSmsSearch.OrderFunctions.ID, OrderType.DESC);

  smsList: OutgoingSms.OutgoingSms[] = [];

  constructor(
    private smsService: TaskRecordOutgoingSmsService,
    private dialog: MatDialog,
    private configurationService: ConfigurationService) {
  }

  ngOnInit() {
    this.loadList()
  }

  pageChanged(selectedPage: number) {
    this.loadList(selectedPage);
  }

  itemsPerPageChanged(itemsPerPage: number) {
    this.queryModel.itemsPerPage = itemsPerPage;
    this.loadList(1);
  }

  orderBy(field: OrderFieldFunction<OrderField.OutgoingSms>) {
    this.queryModel.onOrderFieldChanged(field);
    this.loadList(1);
  }

  loadList(pageNumber?: number) {
    const requestedPage = pageNumber ? pageNumber : this.queryModel.currentPage;
    this.smsService.query(this.getQueryRequest(requestedPage)).subscribe((result: QueryResult<OutgoingSms.OutgoingSms>) => {
      this.smsList = [];
      result.items.forEach((sms: OutgoingSms.OutgoingSms) => {
        this.smsList.push(sms);
      });
      this.queryModel.currentPage = requestedPage;
      this.queryModel.totalNumberOfItems = result.pagingResult.totalNumberOfItems;
      this.queryModel.currentNumberOfItems = result.pagingResult.currentNumberOfItems;
    });
  }

  private createFilter() {
    return (f: FilterField.OutgoingSms) => CriteriaBuilder.builder()
      .build();
  }

  private getQueryRequest(requestedPage?: number): OutgoingSms.QueryRequest {
    const order = this.queryModel.createOrderFunction();
    const filter = this.createFilter();
    return {
      taskId: this.taskId,
      taskRecordId: this.taskRecordId,
      fields: f => f.each,
      order: order,
      filter: filter,
      paging: requestedPage ? {
        pageNumber: requestedPage,
        numberOfItems: this.queryModel.itemsPerPage
      } : undefined,
    };
  }


  resendSms(sms: OutgoingSms.OutgoingSms) {
    TaskRecordOutgoingSmsSendDialogComponent.openDialog(this.dialog, {
      taskId: this.taskId,
      taskRecordId: this.taskRecordId,
      outgoingSms: sms
    }, result => {
      if (result?.success) {
        this.loadList();
      }
    });
  }

  getStateKey(state: OutgoingSms.SmsState): string {
    return OutgoingSms.smsStates.find(s => s.state === state)!.stringKey;
  }
  getSendModeKey(sendMode: OutgoingSms.SmsSendMode): string {
    return OutgoingSms.smsSendModes.find(s => s.sendMode === sendMode)!.stringKey;
  }
  getIntegrationType(integrationType: SmsTemplate.SmsIntegrationType): string {
    return SmsTemplate.integrationTypes.find(s => s.id === integrationType)!.itemName;
  }
}
